import { ReactNode } from 'react';
import { cn } from './utils';

interface FieldHintProps {
  children: ReactNode;
  className?: string;
}

export const FieldHint = ({ children, className }: FieldHintProps) => (
  <p className={cn('mb-2 text-xs text-neutral-500', className)}>{children}</p>
);
